var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIconPub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.788 5.183a2.885 2.885 0 0 0-2.12-.933c-1.428 0-2.614 1.034-2.879 2.407A2.063 2.063 0 0 0 7 8.712c0 .141.02.278.046.411h10.956c.03-.133.05-.269.05-.41 0-.799-.472-1.482-1.145-1.785.015-.098.03-.196.03-.298 0-1.067-.851-1.931-1.9-1.931-.48 0-.914.185-1.249.484zm5.655 5.548c.859 0 1.557.707 1.557 1.575v3.936c0 .868-.698 1.574-1.556 1.574H17.89v2.36c0 .87-.697 1.574-1.556 1.574H8.557c-.86 0-1.557-.704-1.557-1.573v-9.445zm.005 5.497H17.9v-3.945h1.55zm-3.101 2.314h-1.55v-5.524h1.55zm-4.654 0h1.55v-5.524h-1.55zm-1.552 0H8.59v-5.524h1.552z",
    clipRule: "evenodd"
  })));
}
export default SvgMarkerIconPub;